export default function survivorsForTournament(races, tickets) {
  var raceToNumber = races.reduce((accum, race, i) => {
    accum[race.get("id")] = i;
    return accum;
  }, {});

  return races.map((race) =>
    tickets.filter((ticket) => {
      var raceId = ticket.get("eliminated_by_race_id");
      if (raceId === null) {
        return true;
      }
      if (raceToNumber[raceId] > raceToNumber[race.get("id")]) {
        return true;
      }
      return false;
    })
  );
}
